<ion-button color="primary" (click)="clockIn()">
    Clock In
</ion-button>
<ion-button color="primary" (click)="clockOut()">
    Clock Out
</ion-button>
